var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/tonepress", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.press
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.createPress.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.contentOrder.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.active,
                                  expression: "rules.active"
                                }
                              ],
                              attrs: {
                                label: "Release Type",
                                "data-vv-name": "Release Type",
                                "cus-name": "Release Type",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.contentOrder,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.press.contentOrder,
                                callback: function($$v) {
                                  _vm.$set(_vm.press, "contentOrder", $$v)
                                },
                                expression: "press.contentOrder"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.topicSubHead,
                              expression: "rules.topicSubHead"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Heading",
                            placeholder: "Enter Heading",
                            "data-vv-name": "Heading",
                            "cus-name": "Heading",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.press.topicSubHead,
                            callback: function($$v) {
                              _vm.$set(_vm.press, "topicSubHead", $$v)
                            },
                            expression: "press.topicSubHead"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("label", [_vm._v("Published Date")]),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            required: "",
                            "input-class": "form-control",
                            label: "Published Date",
                            placeholder: "Select Date",
                            type: "date",
                            "input-format": "DD-MM-YYYY",
                            "auto-continue": ""
                          },
                          model: {
                            value: _vm.publishDate,
                            callback: function($$v) {
                              _vm.publishDate = $$v
                            },
                            expression: "publishDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.topicSubHeadContents,
                              expression: "rules.topicSubHeadContents"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Description",
                            placeholder: "Enter Description",
                            "data-vv-name": "Description",
                            "cus-name": "Description",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.press.topicSubHeadContents,
                            callback: function($$v) {
                              _vm.$set(_vm.press, "topicSubHeadContents", $$v)
                            },
                            expression: "press.topicSubHeadContents"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.pdfUrl,
                              expression: "rules.pdfUrl"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Link URL",
                            placeholder: "Enter URL",
                            "data-vv-name": "Link URL",
                            "cus-name": "Link URL",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.press.pdfUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.press, "pdfUrl", $$v)
                            },
                            expression: "press.pdfUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.status.length
                      ? _c(
                          "div",
                          { staticClass: "col-3" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.active,
                                  expression: "rules.active"
                                }
                              ],
                              attrs: {
                                label: "Status",
                                "data-vv-name": "active",
                                "cus-name": "active",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.status,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.press.active,
                                callback: function($$v) {
                                  _vm.$set(_vm.press, "active", $$v)
                                },
                                expression: "press.active"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Create Press Release\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Add Press Release")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d6d35c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d6d35c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Press/CreatePress.vue
// module id = y9kh
// module chunks = 0